import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { CreateChancel, ErrMessage, SelectAutocompleteMultiple } from 'components';
import { assessmentActions, httpRequestsOnErrorsActions, httpRequestsOnSuccessActions } from 'store';
import { FindLoad, FindErrorItem, useModal, FindSuccessItem } from 'utils';
import { assessmentList } from './constants';

export const AddAssessment = ({ info, requestParams }) => {
    const ACTION_TYPE = 'CREATE_ASSESSMENT';
    const client = useSelector((state) => state.client.clientItemInfo);
    const dispatch = useDispatch();
    const success = FindSuccessItem(ACTION_TYPE);
    const loader = FindLoad(ACTION_TYPE);
    const backError = FindErrorItem(ACTION_TYPE);
    const { close, open } = useModal();
    const {
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm();

    useEffect(() => {
        dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
    }, []);

    useEffect(() => {
        if (info) {
            reset(info);
        }
    }, [info]);

    const VbmappIframeEmbed = ({ token, learnerId }) => {
        const mountRef = useRef(null);

        useEffect(() => {
            const script = document.createElement('script');
            script.src = 'https://api-sandbox.vbmappapp.com/javascripts/iframe_support.js';
            script.onload = () => {
                if (window.openAssessmentIframe && mountRef.current) {
                    window.openAssessmentIframe('dmtd-rest-api', 'en', token, 'vbmapp', learnerId, null, mountRef.current);
                }
            };
            document.head.appendChild(script);
        }, [token, learnerId]);

        useEffect(() => {
            return () => {
                dispatch(assessmentActions.saveAssessment(client?.id, requestParams));
            };
        }, []);

        return <div ref={mountRef} style={{ height: '90vh', width: '90vw' }} />;
    };

    useEffect(() => {
        if (success) {
            open(<VbmappIframeEmbed token={success?.data?.token} learnerId={success?.data?.learnerId} />, {
                styles: {
                    wrapperStyle: { padding: '0px', borderRadius: '8px' },
                    bodyStyle: { padding: '0px', borderRadius: '8px' },
                },
            });
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
        }
    }, [success]);

    const handleCreate = () => {
        dispatch(assessmentActions.createAssessment(client?.id));
    };

    return (
        <div style={{ width: 400 }}>
            <p className="modal-header-title">Add Assessment</p>
            <form onSubmit={handleSubmit(handleCreate)}>
                <div className="modal-body-wrapper">
                    <SelectAutocompleteMultiple
                        options={assessmentList}
                        renderValue={(option) => option?.name}
                        label={'Type*'}
                        name="type"
                        control={control}
                        rules={{
                            required: 'Please select a type from the dropdown.',
                        }}
                    />

                    {backError?.error && <ErrMessage text={backError?.error} />}
                </div>
                <CreateChancel
                    type="submit"
                    loader={!!loader.length}
                    create={'Start Assessment'}
                    chancel={'Cancel'}
                    onClose={close}
                    buttonWidth="100%"
                    cancelRight={'24px'}
                />
            </form>
        </div>
    );
};
